import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import UserProfile from '../views/UserProfile.vue'
import Higlight from '../views/Higlight.vue'
import Login from '../views/Login.vue'

Vue.use(Router)

function guardMyroute(to, from, next) {
  var token = localStorage.token
  if (token == null || token == undefined || token == "") {
    next('/');
  } else {
    next();
  }
}

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Login',
      component: Login

    },
    {
      path: '/Highlight',
      name: 'Higlight',
      component: Higlight,
      beforeEnter : guardMyroute,
    },

    {
      path: '/profile/:name',
      props: true,
      name: 'UserProfile',
      component: UserProfile,
      beforeEnter : guardMyroute,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js